/**
 * @description Connecte l'utilisateur si le « refresh token » existe et
 * est valide et le « access token » n'est pas initialisé. identifie l'utilisateur
 * en tant que visiteur le cas échéant
 * @param {Object} api - Objet représentant l'api des requêtes
 * @returns {Object} Objet représentant l'utilisateur connecté
 * @author Alexandre Gallant
 * @author Félix Bordage
 */
export async function connectUser(api) {
  const refreshToken = getRefreshToken();

  if (refreshToken.token == undefined) {
    return { role: "guest" };
  }
  if (await refreshTokens(refreshToken, api)) {
    try {
      return await getUserInfo(api);
      // si getUserInfo fail, on assume le même comportement que si
      // le refreshTokens échoue, bref, on exploite return et on a besoin d'un
      // catch vide
      // eslint-disable-next-line no-empty
    } catch {}
  }
  deleteRefreshToken();
  return { role: "guest" };
}
/**
 * @description Effectue une requête pour obtenir les informations de rôle de
 * l'utilisateur courant
 * @param {Object} api - Objet représentant l'api des requêtes
 */
async function getUserInfo(api) {
  let userInfo = (await api.getUserInfo()).data;
  return {
    role: userInfo.isSuperAdmin == 1 ? "admin" : "user",
    id: userInfo.id,
    client_id: userInfo.client_id
  };
}
/**
 * @description Récupère le « access token » auprès de l'api et l'initialise
 * @author Alexandre Gallant
 * @author Félix Bordage
 * @param {Object} token - refreshtoken nécessaire au login
 * @param {Object} api - Objet représentant l'api des requêtes
 * @returns Vrai si la connexion réussit
 */
async function refreshTokens(token, api) {
  try {
    let result = await api.loginWithToken(token.token);
    setRefreshToken(result.data.refresh_token, token.storage === "local");
    setAccessToken(result.data.access_token, api);
    return true;
  } catch {
    return false;
  }
}
/**
 * @description Initialie le « access token » avec la valeur donnée
 * @author Alexandre Gallant
 * @param {String} token la valeur à assigner
 * @param {Object} api - Objet représentant l'api des requêtes
 */
function setAccessToken(token, api) {
  api.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}
/**
 * @description Sauvegarde le « refresh token » dans le « local storage » ou le « session storage » selon les paramètres fournis
 * @author Alexandre Gallant
 * @param {String} token La valeur à sauvegarder
 * @param {Boolean} useLocalStorage Si la valeur doit être sauvegardée dans le « local storage »
 */
function setRefreshToken(token, useLocalStorage) {
  if (useLocalStorage) {
    localStorage.setItem("refresh_token", token);
  } else {
    sessionStorage.setItem("refresh_token", token);
  }
}
/**
 * @description Récupère la valeur du « refresh token »
 * @author Alexandre Gallant
 * @returns {String} La valeur du « refresh token »
 */
function getRefreshToken() {
  let token = sessionStorage.getItem("refresh_token");
  if (token != "undefined" && token != null) {
    return {
      token: token,
      storage: "session"
    };
  }
  token = localStorage.getItem("refresh_token");
  if (token != "undefined" && token != null) {
    return {
      token: token,
      storage: "local"
    };
  }
  return {
    token: undefined,
    storage: "none"
  };
}
/**
 * @description Supprime le « refresh token »
 * @author Alexandre Gallant
 */
function deleteRefreshToken() {
  localStorage.removeItem("refresh_token");
  sessionStorage.removeItem("refresh_token");
}
